import React from "react";
import { Card } from "@mui/material";

import Box from "themeComponents/Box";

interface CourseCardShellProps {
  children: React.ReactNode;
  onClick?: () => void;
  hoverable?: boolean;
  bodyPadding?: number;
  bodyFlex?: number;
  cardSx?: any;
  bodySx?: any;
}

function CourseCardShell({
  children,
  onClick,
  hoverable = true,
  bodyPadding = 2.5,
  bodyFlex = 1,
  cardSx,
  bodySx,
}: CourseCardShellProps): React.JSX.Element {
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        cursor: onClick ? "pointer" : "default",
        transition: hoverable ? "transform 0.2s, box-shadow 0.2s" : undefined,
        ...(hoverable
          ? {
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: 6,
              },
            }
          : {}),
        ...(cardSx || {}),
      }}
      onClick={onClick}
    >
      <Box p={bodyPadding} flex={bodyFlex} display="flex" flexDirection="column" sx={bodySx} {...({} as any)}>
        {children}
      </Box>
    </Card>
  );
}

export default CourseCardShell;